export default __webpack_public_path__ + "static/media/logout-16px.5173bdcc.svg";